var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteWarningButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.7325 4.20192C11.4837 2.78296 13.5164 2.78295 14.2676 4.20192L21.6067 18.0647C22.3119 19.3967 21.3463 21.0004 19.8391 21.0004H5.16095C3.6538 21.0004 2.68819 19.3967 3.39337 18.0647L10.7325 4.20192ZM19.8391 19.0004L12.5 5.1377L5.16094 19.0004L19.8391 19.0004Z",
    fill: "#FF3225"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 10.0004C11.5 9.44815 11.9478 9.00043 12.5 9.00043C13.0523 9.00043 13.5 9.44815 13.5 10.0004V14.0004C13.5 14.5527 13.0523 15.0004 12.5 15.0004C11.9478 15.0004 11.5 14.5527 11.5 14.0004V10.0004Z",
    fill: "#FF3225"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 17.0004C13.5 17.5527 13.0523 18.0004 12.5 18.0004C11.9478 18.0004 11.5 17.5527 11.5 17.0004C11.5 16.4481 11.9478 16.0004 12.5 16.0004C13.0523 16.0004 13.5 16.4481 13.5 17.0004Z",
    fill: "#FF3225"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteWarningButton);
export default __webpack_public_path__ + "static/media/DeleteWarningButton.6da7f5f0d7525e8b9e71a654518a1e66.svg";
export { ForwardRef as ReactComponent };